/**
 * useTheme — leitura do tema atual e ação de toggle (dark ↔ light).
 *
 * Atalho sobre `useThemeStore`. A aplicação da classe `dark` no `<html>`
 * e a persistência em localStorage já são responsabilidade do store —
 * este hook apenas expõe o que a UI consome.
 *
 * Spec §4 (Tema e Identidade Visual): "Dark mode: tokens invertidos via
 * class='dark' no <html>, ativado por Zustand + localStorage".
 */

import { useThemeStore, type Theme } from '@/store/theme.store'

export interface UseThemeResult {
  /** Tema corrente. */
  theme: Theme
  /** Alterna entre `light` e `dark`. */
  toggle: () => void
  /** Define um tema específico (útil para preferências em /settings). */
  setTheme: (theme: Theme) => void
}

export function useTheme(): UseThemeResult {
  const theme = useThemeStore((s) => s.theme)
  const toggle = useThemeStore((s) => s.toggle)
  const setTheme = useThemeStore((s) => s.setTheme)
  return { theme, toggle, setTheme }
}
